import { viewports } from 'app/constants/breakpoints';

const viewportMap = {
  [viewports.SMALL]: 0,
  [viewports.MEDIUM]: 1,
  [viewports.LARGE]: 2,
  [viewports.X_LARGE]: 2,
};

const getResponsiveImage = (images, viewport) => {
  if (typeof images === 'string') {
    return images;
  }

  return images[viewportMap[viewport]];
};

export default getResponsiveImage;



// WEBPACK FOOTER //
// ./src/utils/getResponsiveImage.js